import router from '@/router';
import { useAuthStore } from '@/stores/auth';
import { useErrorStore } from '@/stores/errorStore';
import { useNotificationStore } from '@/stores/notification';
import axios from 'axios';

const api = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || '/api', // You can configure this
    timeout: 0
});

api.defaults.headers.common['Accept'] = 'application/json';

// Request interceptor
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        delete config.headers.Authorization;
    }

    // Offline check
    if (!navigator.onLine) {
        const error = {
            message: 'You are offline',
            isOffline: true,
            config,
        };

        const notify = useNotificationStore();

        // Define retry logic
        notify.showMessage(
            'You are offline. Please check your internet connection.',
            'error',
            () => {
                router.go(0);
            }
        );

        // Prevent request from going out
        return Promise.reject(error);
    }

    return config;
});

// Response interceptor
api.interceptors.response.use(
    response => {
        return response;
    },
    async error => {
        const notify = useNotificationStore();

        if (error?.response?.status === 401) {
            useErrorStore().setUnauthorized(true);
            const auth = useAuthStore();

            if(error?.config?.url !== '/user') {
                await auth.fetchUser();
            }
            
            if (!auth.token) {
                router.push('/');
                return Promise.reject(error);
            }

            return Promise.reject();
        } else if (error?.response?.status === 404) {
            useErrorStore().setNotFound(true);
            return Promise.reject();
        } else if (error?.response && error?.response?.status !== 422) {
            // Define retry logic
            notify.showMessage(
                error?.response?.data?.message || "Something went wrong please try again later",
                'error',
                () => {
                    router.go(0);
                }
            );
        } else if (!error?.response) {
            notify.showMessage(
                error?.message || "Something went wrong please try again later",
                'error',
                () => {
                    router.go(0);
                }
            );
        }

        return Promise.reject(error);
    }
);

export default api;
